import LazyLoad from 'vanilla-lazyload';



$(document).ready(function() {
  new LazyLoad({
    elements_selector: '.lazy',
  });
});